import React, { useState } from 'react';

import { Divider } from '@material-ui/core';

import { accentColors, applyAccentColorOptions,
         popoverHeadingColors, popoverHeadingStyleOptions,
         popoverHeadingSizeOptions, popoverBgPatternOptions } from '../../config/hotspot';

import { Target } from ".";
import { ColorPicker, ImageUpload, PackageImport, Select, TitleInput } from '../EditorFormElements';
import { FormFieldWrapper, SortableList } from '../Global';
import { EditorTabs } from '../Interface';


export const HotspotForm = ({given, setItem, ...props}) => {
  const [applyAccentColor,setApplyAccentColor] = useState(given.applyAccentColor || '')

  const onAccentChange = (name,value) => {
    setApplyAccentColor(value);
  }


  
  const generalTab = (
    <>
      <PackageImport />
        
      <FormFieldWrapper>
        <TitleInput 
          label="Item Title"
          defaultText="Enter item title"
          help="Title should match the background image title to support screen readers."
          given={given.title}
        /> 
      </FormFieldWrapper>
    </>
  )

  const stylesTab = <>
    <FormFieldWrapper>
      <ImageUpload 
        label="Background Image" 
        name="bg"
        includeAlt={true} 
        altLabel="Image Alt Text"
        altPlaceholder="Provide image alt text to support screen readers."
        tooltip="Upload an image to display as the background. Recommended image size should have a width of 1920px and a min height of 768px. File size should not exceed 250KB."
        given={given.bg}
      />                
    </FormFieldWrapper>

    <Divider/>

    <h4 className="form-section-header">Popover Styles</h4>
    
    <FormFieldWrapper>  

      <ColorPicker 
        name="headingColor"
        label="Heading Color" 
        colors={popoverHeadingColors} 
        given={given.headingColor}
      />

      <Select 
        label="Set Accent Color"
        name='applyAccentColor'
        options={applyAccentColorOptions}
        given={given.applyAccentColor}
        callback={onAccentChange}
      /> 

      {applyAccentColor === 'global' ?
        <ColorPicker 
          name="accentColor"
          label="Accent Color" 
          colors={accentColors} 
          given={given.accentColor}
        />
      : '' }

      <Select 
        label="Popover Heading Style" 
        name='popoverHeadingStyle' 
        options={popoverHeadingStyleOptions}
        given={given.popoverHeadingStyle}
      /> 

      <Select 
        label="Popover Heading Size" 
        name='popoverHeadingSize' 
        options={popoverHeadingSizeOptions}
        given={given.popoverHeadingSize}
      /> 


      <Select 
        label="Popover Background Pattern"
        name='bgPattern' 
        options={popoverBgPatternOptions}
        given={given.bgPattern}
      /> 
    </FormFieldWrapper>
  </>  

    
  const contentTab = (
    <SortableList
      label="Target"
      name="hotspots"
      given={given.hotspots}
      min={1}
    >
      <Target 
        showColorPicker={applyAccentColor === 'individual'}
      />
    </SortableList>
  )

  return (
    <EditorTabs
      general={generalTab}
      styles={stylesTab}
      content={contentTab}
    />
  );

}
